import { Theme } from '@mui/material/styles';
// eslint-disable-next-line import/no-extraneous-dependencies
import { merge } from 'lodash';

import Button from './Button';
import IconButton from './IconButton';
import Paper from './Paper';
import TextField from './TextField';
import Divider from './Divider';
import Tabs from './Tabs';
import Tab from './Tab';
import Slider from './Slider';
import ListItemButton from './ListItemButton';
import Checkbox from './Checkbox';

export default function ComponentsOverrides(theme: Theme) {
  return merge(
    Paper(theme),
    Button(theme),
    IconButton(theme),
    TextField(theme),
    Divider(theme),
    Tabs(theme),
    Slider(theme),
    Tab(theme),
    Checkbox(theme),
    ListItemButton(theme),
  );
}
